export const ARTICLES = 'articles';
export const PRODUCTS = 'products';



// WEBPACK FOOTER //
// ./src/Components/search/constants/index.js